/**
 * Content 서버 API 인스턴스
 *
 * openapi-fetch 기반의 타입 안전한 API 클라이언트
 */
import { stepinMiddleware } from '@/@shared/middleware/middleware';
import type { paths } from '@/domains/content/types/schema';
import { API_CONFIG } from '@/model/openAPI/config';
import createClient from 'openapi-fetch';

/**
 * Content 서버 클라이언트 생성 함수
 */
const createContentClient = () => {
	const client = createClient<paths>({
		baseUrl: API_CONFIG.content.baseUrl,
	});

	// 공통 미들웨어 적용
	client.use(stepinMiddleware);

	return client;
};

/**
 * Content 서버 싱글톤 인스턴스
 */
export const contentFetcher = createContentClient();

/**
 * HTTP 메서드별 함수들 export
 */
export const { GET, POST, PUT, PATCH, DELETE } = contentFetcher;

/**
 * 타입 export
 */
export type ContentFetcher = typeof contentFetcher;
export type ContentPaths = paths;
